import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { App } from '@df/core/app';
import { SizebayService } from './sizebay.service';

@Component({
    selector: 'sizebay',
    templateUrl: './sizebay.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SizebayComponent {
    protected app = inject(App);
    private sizebayService = inject(SizebayService);

    ngOnInit(): void {
        this.load();
    }

    load() {
        if (!this.app.isPlatformBrowser) {
            return;
        }
        this.removeSizebayGeneratedElements();
        this.createSizebayContainer();
        this.sizebayService.init();
    }

    private createSizebayContainer(): void {
        if (!document.getElementById('sizebay-container')) {
            const container = document.createElement('div');
            container.id = 'sizebay-container';

            const parentElement = document.getElementById('sizebay-wrapper');
            if (parentElement) {
                parentElement.appendChild(container);
            }
        }
    }

    private removeSizebayGeneratedElements(): void {
        const container = document.getElementById('szb-container');
        if (container) {
            container.remove();
        }
    }
}
